// Two teams shaking on a trade (PLAN-2026-10-31-a-handshake-a-dance-and-the-
// photo §1): their characters face to face at the top of a trade's detail
// once it has gone through, the right hands meeting between them.
//
// THE SECOND STANDS WITH ITS POSE THE OTHER WAY ROUND (`mirror`), close
// enough that the hand each holds out is the same hand on the screen. A team
// with no face stands as its placard (B-488), and then nobody holds out a
// hand to a pole: the two stand side by side.

import type { CSSProperties } from 'react';
import { FIGURE_BOX } from './FigureArt';
import { TeamFigure, teamFace, type FigureTeam } from './TeamFigure';

/** How far apart the two stand, in the character's box: where the `shaking` hands meet. */
const APART = 92;

export function Handshake({
  left,
  right,
  height = 104,
}: {
  left: FigureTeam;
  right: FigureTeam;
  /** Each character's drawn height. */
  height?: number;
}) {
  const shaking = teamFace(left) !== null && teamFace(right) !== null;
  const width = Math.round((height * FIGURE_BOX.w) / FIGURE_BOX.h);
  const overlap = shaking ? Math.round((width * (FIGURE_BOX.w - APART)) / FIGURE_BOX.w) : 0;
  const mood = shaking ? 'shaking' : 'idle';
  return (
    <span
      className="fsp-handshake"
      style={{ '--fsp-handshake-overlap': `${overlap}px` } as CSSProperties}
      aria-hidden
    >
      <TeamFigure team={left} mood={mood} height={height} />
      <TeamFigure team={right} mood={mood} mirror height={height} />
    </span>
  );
}
